module.exports = "<p>\n  page-note-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/page-note-found/page-note-found.component.html
// module id = ../../../../../src/app/page-note-found/page-note-found.component.html
// module chunks = main